import React, { useState, useReducer, useCallback, useEffect } from 'react';

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const defaultResult = {
  data: null,
  loading: false,
  error: null
};
const defaultTransformFunction = (res) => res == null ? void 0 : res.data;
const useAsyncRequest = (options) => {
  const { defaultData = null, requestFunctions, auto = true } = options;
  if (!requestFunctions || !Array.isArray(requestFunctions) || requestFunctions.length == 0) {
    throw new Error('"requestFunctions" is required');
  }
  const abortController = new AbortController();
  const [updateKey, setUpdateKey] = useState(() => {
    return auto ? +new Date() : 0;
  });
  const [result, dispatch] = useReducer((result2, action) => {
    switch (action.type) {
      case "FETCH" /* FETCH */:
        return __spreadProps(__spreadValues$1({}, result2), { data: defaultData, loading: true, error: null });
      case "SUCCESS" /* SUCCESS */:
        return __spreadProps(__spreadValues$1({}, result2), { data: action.data, loading: false, error: null });
      case "ERROR" /* ERROR */:
        return __spreadProps(__spreadValues$1({}, result2), { data: defaultData, loading: false, error: action.error });
      case "RESET" /* RESET */:
        return __spreadProps(__spreadValues$1({}, result2), { data: defaultData, loading: false, error: null });
      default:
        return result2;
    }
  }, Object.assign({}, defaultResult, { data: defaultData }));
  const requestFunctionsCallback = useCallback(async () => {
    const results = [];
    for (const request2 of requestFunctions) {
      const res = await request2.func(__spreadProps(__spreadValues$1({}, request2.payload), { controller: abortController }));
      if (res instanceof Error) {
        throw res;
      }
      let data = null;
      if (request2.transform) {
        data = request2.transform(res);
      } else {
        data = defaultTransformFunction(res);
      }
      results.push(data);
    }
    return results;
  }, [JSON.stringify(requestFunctions.map((req) => req.payload)), updateKey]);
  const fetchDataCallback = useCallback(async () => {
    if (updateKey === 0) {
      return null;
    }
    dispatch({ type: "FETCH" /* FETCH */ });
    try {
      const data = await requestFunctionsCallback();
      dispatch({ type: "SUCCESS" /* SUCCESS */, data });
      return data;
    } catch (error) {
      dispatch({ type: "ERROR" /* ERROR */, error });
      return null;
    }
  }, [requestFunctionsCallback]);
  useEffect(() => {
    fetchDataCallback();
    return () => {
      if (abortController) {
        abortController.abort();
      }
    };
  }, [fetchDataCallback]);
  const refetch = useCallback(() => {
    setUpdateKey(+new Date());
  }, [fetchDataCallback]);
  const request = useCallback(() => {
    return fetchDataCallback();
  }, [fetchDataCallback]);
  const reset = useCallback(() => {
    setUpdateKey(0);
    dispatch({ type: "RESET" /* RESET */ });
  }, [dispatch]);
  return __spreadProps(__spreadValues$1({}, result), { refetch, request, reset });
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AsyncRequest = (_a) => {
  var _b = _a, {
    defaultData = null,
    requestFunctions,
    loading: loadingElement = "Loading...",
    success: SuccessComponent,
    error: ErrorComponent,
    children
  } = _b, rest = __objRest(_b, [
    "defaultData",
    "requestFunctions",
    "loading",
    "success",
    "error",
    "children"
  ]);
  const { data, loading, error, refetch } = useAsyncRequest({
    defaultData,
    requestFunctions
  });
  return /* @__PURE__ */ React.createElement("div", __spreadValues({}, rest), loading && loadingElement, error && (ErrorComponent && /* @__PURE__ */ React.createElement(ErrorComponent, {
    error,
    refetch
  }) || "error"), data && /* @__PURE__ */ React.createElement(SuccessComponent, {
    data,
    refetch
  }), children);
};

var index = {
  useAsyncRequest,
  AsyncRequest
};

export { AsyncRequest, index as default, useAsyncRequest };
